import { MeasurementDetailsFragment } from '@spotify/confidence-graphql';

import { AverageCodeSnippetProps } from './averageSnippet';
import { RatioCodeSnippetProps } from './ratioSnippet';

export type MeasurementInput = {
  entity?: string | null;
  factTable?: string | null;
  typeSpec?: MeasurementDetailsFragment['typeSpec'];
  nullHandling?: MeasurementDetailsFragment['nullHandling'];
  filter?: MeasurementDetailsFragment['filter'];
};

export const toAverageSnippetConfig = (
  measurement: MeasurementInput,
): AverageCodeSnippetProps | undefined => {
  const spec = measurement.typeSpec?.averageMetricSpec;
  if (!spec) {
    return undefined;
  }

  return {
    entity: measurement.entity ?? undefined,
    factTable: measurement.factTable ?? undefined,
    measurement: spec.measurement?.name ?? undefined,
    aggregationMethod: spec.aggregation?.type,
    aggregationThreshold: spec.aggregation?.threshold ?? undefined,
    aggregationCap: spec.aggregation?.cap ?? undefined,
    replaceMissingWithZero:
      measurement.nullHandling?.replaceEntityNullWithZero ?? false,
    filter: measurement.filter,
  };
};

export const toRatioSnippetConfig = (
  measurement: MeasurementInput,
): RatioCodeSnippetProps | undefined => {
  const spec = measurement.typeSpec?.ratioMetricSpec;
  if (!spec) {
    return undefined;
  }

  return {
    entity: measurement.entity ?? undefined,
    factTable: measurement.factTable ?? undefined,
    numerator: spec.numerator?.name ?? undefined,
    denominator: spec.denominator?.name ?? undefined,
    numeratorAggregation: spec.numeratorAggregation?.type,
    denominatorAggregation: spec.denominatorAggregation?.type,
    numeratorCap: spec.numeratorAggregation?.cap ?? undefined,
    denominatorCap: spec.denominatorAggregation?.cap ?? undefined,
    replaceMissingWithZero:
      measurement.nullHandling?.replaceEntityNullWithZero ?? false,
    filter: measurement.filter,
    numeratorFilter: spec.numeratorFilter,
  };
};
